(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@wangeditor/editor"), require("katex"));
	else if(typeof define === 'function' && define.amd)
		define(["@wangeditor/editor", "katex"], factory);
	else if(typeof exports === 'object')
		exports["WangEditorPluginFormula"] = factory(require("@wangeditor/editor"), require("katex"));
	else
		root["WangEditorPluginFormula"] = factory(root["wangEditor"], root["katex"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__3857__, __WEBPACK_EXTERNAL_MODULE__1771__) {
return 